import { Link } from "react-router-dom";

const resources = [
  {
    title: "Beginner Guides",
    description: "Start from scratch with step-by-step tutorials designed for new Vigorbuy Spreadsheet users.",
    icon: "ri-book-open-line",
    link: "/vigorbuy-spreadsheet-guide",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20spreadsheet%20notes%20next%20to%20laptop%2C%20warm%20cream%20background%2C%20terracotta%20pen%20and%20coffee%20cup%2C%20soft%20natural%20light%2C%20inviting%20educational%20editorial%20photography%2C%20clean%20cozy%20learning%20atmosphere&width=600&height=400&seq=res-beginner&orientation=landscape",
  },
  {
    title: "Comparison Articles",
    description: "See how Vigorbuy Spreadsheet compares with Excel, Google Sheets and other popular tools.",
    icon: "ri-scales-3-line",
    link: "https://kaspreadsheet.com",
    isInternal: false,
    image: "https://readdy.ai/api/search-image?query=Two%20laptops%20side%20by%20side%20displaying%20different%20spreadsheet%20dashboards%20for%20comparison%2C%20warm%20cream%20desk%20setup%2C%20terracotta%20and%20beige%20accents%2C%20professional%20editorial%20photography%2C%20clean%20modern%20workspace%20with%20natural%20lighting&width=600&height=400&seq=res-comparison&orientation=landscape",
  },
  {
    title: "Templates",
    description: "Download ready-made spreadsheet templates for business, inventory and daily tasks.",
    icon: "ri-file-list-3-line",
    link: "https://kaspreadsheet.com",
    isInternal: false,
    image: "https://readdy.ai/api/search-image?query=Multiple%20spreadsheet%20template%20previews%20displayed%20on%20laptop%20screen%20with%20organized%20grid%20layout%2C%20warm%20cream%20desk%2C%20terracotta%20notebook%2C%20modern%20workspace%2C%20soft%20natural%20lighting%2C%20clean%20professional%20editorial%20photography&width=600&height=400&seq=res-templates&orientation=landscape",
  },
  {
    title: "Security Guides",
    description: "Learn best practices to keep your spreadsheet data safe and protected at all times.",
    icon: "ri-shield-check-line",
    link: "#safety",
    isInternal: false,
    image: "https://readdy.ai/api/search-image?query=Abstract%20security%20concept%20with%20padlock%20icon%20on%20laptop%20screen%20representing%20data%20protection%2C%20shield%20visual%2C%20warm%20beige%20and%20cream%20tones%2C%20modern%20clean%20workspace%2C%20soft%20natural%20light%2C%20trustworthy%20professional%20aesthetic&width=600&height=400&seq=res-security&orientation=landscape",
  },
  {
    title: "Productivity Tips",
    description: "Boost your efficiency with proven tips and tricks for smarter spreadsheet management.",
    icon: "ri-lightbulb-line",
    link: "https://kaspreadsheet.com",
    isInternal: false,
    image: "https://readdy.ai/api/search-image?query=Productive%20organized%20desk%20with%20laptop%20showing%20efficiency%20dashboard%2C%20sticky%20notes%20with%20tips%2C%20modern%20cream%20and%20terracotta%20workspace%20accessories%2C%20warm%20natural%20lighting%2C%20clean%20motivational%20productivity%20editorial%20photography&width=600&height=400&seq=res-productivity&orientation=landscape",
  },
];

export default function ResourcesSection() {
  return (
    <section id="resources" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Latest Vigorbuy Spreadsheet Resources
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Explore our growing collection of guides, templates, and expert resources to master spreadsheet management.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {resources.map((res) => {
            const isInternal = res.isInternal;
            const linkContent = (
              <>
                <div className="w-full h-40 md:h-44 rounded-lg overflow-hidden mb-4 bg-background-200/40">
                  <img
                    src={res.image}
                    alt={res.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-3">
                  <i className={`${res.icon} text-lg`}></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                  {res.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {res.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-label font-medium text-primary-600 hover:text-primary-700 transition-colors">
                  Read More
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </>
            );

            if (isInternal) {
              return (
                <Link
                  key={res.title}
                  to={res.link}
                  className="block p-5 bg-background-100 border border-background-200/60 rounded-lg hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
                >
                  {linkContent}
                </Link>
              );
            }

            return (
              <a
                key={res.title}
                href={res.link}
                target="_blank"
                rel="noopener nofollow"
                className="block p-5 bg-background-100 border border-background-200/60 rounded-lg hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
              >
                {linkContent}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}